export const CREATE_CALL_FLOW_ENTRY_SUCCESS = 'CREATE_CALL_FLOW_ENTRY_SUCCESS';
export const CHANGE_CALL_FLOW_ENTRY_SUCCESS = 'CHANGE_CALL_FLOW_ENTRY_SUCCESS';
export const COPY_CALL_FLOW_ENTRY_SUCCESS = 'COPY_CALL_FLOW_ENTRY_SUCCESS';
export const REMOVE_CALL_FLOW_ENTRY_SUCCESS = 'REMOVE_CALL_FLOW_ENTRY_SUCCESS';
export const CHANGE_CALL_FLOW_ENTRIES_SUCCESS = 'CHANGE_CALL_FLOW_ENTRIES_SUCCESS';

export const UPDATE_CALL_FLOW_ENTRIES_START = 'UPDATE_CALL_FLOW_ENTRIES_START';
export const UPDATE_CALL_FLOW_ENTRIES_SUCCESS = 'UPDATE_CALL_FLOW_ENTRIES_SUCCESS';
export const UPDATE_CALL_FLOW_ENTRIES_ERROR = 'UPDATE_CALL_FLOW_ENTRIES_ERROR';
